import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import axios from "axios";
import { LogoutRequest } from "../types/logout.type";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

const logout = async ({ token }: LogoutRequest) => {
  try {
    await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/auth/logout`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default logout;
